declare global {
  interface Window {
    FB?: any;
    fbAsyncInit?: () => void;
  }
}

let facebookSdkPromise: Promise<void> | null = null;

const getFacebookAppId = () => {
  const appId = process.env.REACT_APP_FACEBOOK_APP_ID;

  if (!appId) {
    throw new Error("Missing REACT_APP_FACEBOOK_APP_ID.");
  }

  return appId;
};

export const loadFacebookSdk = (): Promise<void> => {
  if (facebookSdkPromise) {
    return facebookSdkPromise;
  }

  facebookSdkPromise = new Promise((resolve, reject) => {
    if (window.FB) {
      resolve();
      return;
    }

    window.fbAsyncInit = () => {
      window.FB.init({
        appId: getFacebookAppId(),
        cookie: true,
        xfbml: false,
        version: "v20.0",
      });

      resolve();
    };

    const existingScript = document.getElementById("facebook-jssdk");

    if (existingScript) {
      return;
    }

    const script = document.createElement("script");
    script.id = "facebook-jssdk";
    script.src = "https://connect.facebook.net/en_US/sdk.js";
    script.async = true;
    script.defer = true;
    script.onerror = () => reject(new Error("Facebook SDK failed to load."));

    document.body.appendChild(script);
  });

  return facebookSdkPromise;
};

export const getFacebookAccessToken = async (): Promise<string> => {
  await loadFacebookSdk();

  return new Promise((resolve, reject) => {
    if (!window.FB) {
      reject(new Error("Facebook SDK is not available."));
      return;
    }

    window.FB.login(
      (response: any) => {
        const accessToken = response?.authResponse?.accessToken;

        if (!accessToken) {
          reject(new Error("Facebook login was cancelled or failed."));
          return;
        }

        resolve(accessToken);
      },
      { scope: "public_profile,email" },
    );
  });
};
